module.exports = __webpack_public_path__ + "static/index/img/baikal-206.4f6c1a60.jpg";